import { makeStyles, Theme } from '@material-ui/core/styles';
import { red, pink, orange } from '@material-ui/core/colors';

export const useStyles = makeStyles(
  (theme: Theme) => ({
    root: {
      display: 'flex',
    },
    content: {
      flexGrow: 1,
      height: '100vh',
      overflow: 'auto',
    },

    value: {
      fontSize: 34,
      marginBottom: theme.spacing(1),
    },
    yesValue: {
      fontSize: 20,
    },
    title: {
      flexGrow: 1,
      maxWidth: 280,
      //height: 60,
      fontSize: 16,
      marginBottom: theme.spacing(3),
      color: '#757575',
    },
    // content: {
    //   flexGrow: 1,
    //   height: '100vh',
    //   overflow: 'auto',
    // },
    container: {
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(4),
    },
    gridPaper: {
      height: '140px',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      position: 'relative',
      padding: '16px',
      boxSizing: 'border-box',
    },
    paper: {
      padding: theme.spacing(2),
      display: 'flex',
      overflow: 'auto',
      flexDirection: 'column',
    },
    infoContainer: {
      display: 'flex',
      marginBottom: theme.spacing(1),
      alignItems: 'stretch',
    },
    link: {
      display: 'inline-block',
      textTransform: 'uppercase',
      color: theme.palette.info.main,
      letterSpacing: 0.4,
      fontSize: 14,
      //marginLeft: theme.spacing(1),
      //fontWeight: 600,
      margin: `0 ${theme.spacing(3)}px 0 0`,
    },
    // container: {
    //   paddingTop: theme.spacing(2),
    // },
    // tableBox: {
    //   margin: theme.spacing(2, 0, 0),
    // },
    // infoContainer: {
    //   display: 'flex',
    //   height: 50,
    // },
    // title: {
    //   flexGrow: 1,
    //   margin: theme.spacing(1),
    // },
    // paper: {
    //   display: 'flex',
    //   justifyContent: 'center',
    //   justifyItems: 'center',
    //   flexDirection: 'column',
    //   boxShadow: theme.shadows[0],
    // },
    noBorder: {
      border: 'none',
    },
    dataGrid: {
      width: '100%',
      '& .MuiDataGrid-root': {
        border: 'none',
        '& .MuiDataGrid-columnHeaders': {
          backgroundColor: '#f5f5f5',
          fontSize: '0.875rem',
          fontWeight: 600,
          '@media (max-width: 960px)': {
            fontSize: '0.8rem',
            minHeight: '44px !important',
          },
          '@media (max-width: 768px)': {
            fontSize: '0.75rem',
            minHeight: '40px !important',
          },
          '@media (max-width: 480px)': {
            fontSize: '0.7rem',
            minHeight: '36px !important',
          },
        },
        '& .MuiDataGrid-cell': {
          fontSize: '0.875rem',
          padding: '12px 8px',
          '@media (max-width: 960px)': {
            fontSize: '0.8rem',
            padding: '10px 6px',
          },
          '@media (max-width: 768px)': {
            fontSize: '0.75rem',
            padding: '8px 4px',
          },
          '@media (max-width: 480px)': {
            fontSize: '0.7rem',
            padding: '6px 2px',
          },
        },
        '& .MuiDataGrid-row': {
          minHeight: '52px !important',
          '@media (max-width: 960px)': {
            minHeight: '48px !important',
          },
          '@media (max-width: 768px)': {
            minHeight: '44px !important',
          },
          '@media (max-width: 480px)': {
            minHeight: '40px !important',
          },
        },
        '& .MuiDataGrid-footerContainer': {
          '@media (max-width: 768px)': {
            flexDirection: 'column',
            alignItems: 'center',
            gap: '4px',
            padding: '8px',
          },
          '@media (max-width: 480px)': {
            flexDirection: 'column',
            alignItems: 'center',
            gap: '8px',
            padding: '8px',
          },
        },
        '& .MuiTablePagination-toolbar': {
          '@media (max-width: 480px)': {
            flexDirection: 'column',
            height: 'auto',
            minHeight: '52px',
          },
        },
        '& .MuiTablePagination-spacer': {
          '@media (max-width: 480px)': {
            display: 'none',
          },
        },
        '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows': {
          '@media (max-width: 480px)': {
            fontSize: '0.75rem',
            margin: '4px 0',
          },
        },
      },
      '& .MuiDataGrid-root .MuiDataGrid-row.Mui-selected ': {},
      '& .MuiDataGrid-root .MuiDataGrid-row': {
        '&:hover': {
          backgroundColor: 'rgba(255, 80, 95, 0.04)',
        },
      },
      '& .row-background-error': {
        backgroundColor: red[50],
        '&:hover': {
          backgroundColor: red[100],
        },
      },
      '& .row-background-alert': {
        backgroundColor: pink[50],
        '&:hover': {
          backgroundColor: pink[100],
        },
      },
      '& .row-background-transaction': {
        backgroundColor: 'white',
        '&:hover': {
          backgroundColor: 'rgba(255, 80, 95, 0.04)',
        },
      },
      '& .cell-text-color-error': {
        color: pink[700],
      },
      '& .cell-text-color-alert': {
        color: orange[700],
      },
      '& .cell-text-color-transaction': {
        color: 'black',
        fontWeight: '500',
        textTransform: 'capitalize',
      },
      '& .MuiDataGrid-colCellTitle': {
        color: 'black',
        fontWeight: '700',
        textTransform: 'capitalize',
      },
    },
  }),
  {
    index: 1,
  }
);
